export const rootStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  paddingX: 1,
  paddingY: 0.25,
  marginBottom: 0.5,
  borderRadius: 1,
  backgroundColor: theme => theme.palette.action.hover,
  color: theme => theme.palette.primary.main,
  cursor: 'pointer',
  border: 'none',
  font: 'inherit',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: theme => theme.palette.action.selected,
  },
};
